import { inject, injectable } from "inversify";
import { EstimateFiltersModel, EstimateModel, ICPLEstimatesClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IEstimatesService {
  getEstimates(filterModel: EstimateFiltersModel): Promise<EstimateModel[]>;
  getEstimate(estimateID: string): Promise<EstimateModel>;
}

@injectable()
export class EstimatesService implements IEstimatesService {
  @inject(SERVICE_TYPES.CPLEstimatesClient) cplEstimatesClient!: ICPLEstimatesClient;

  async getEstimates(filterModel: EstimateFiltersModel): Promise<EstimateModel[]> {
    return this.cplEstimatesClient.getEstimates(filterModel);
  }

  async getEstimate(estimateID: string): Promise<EstimateModel> {
    return this.cplEstimatesClient.getEstimate(estimateID);
  }
}
